<template>
  <form @submit.prevent="verifyCoupon()" class="card p-3 mb-3">
    <h6>
      <b>¿Tienes un código de descuento?</b>
    </h6>
    <div v-if="statusCoupon">
      <p>
        <span class="text-success small">Cupón aplicado correctamente.</span><br />
        <span class="text-dark small">Código válido para las entradas de tipo: <b>{{ typeCuopon }}</b></span>
        <a href="#" @click.prevent="removeCoupon()" class="ml-2 text-danger small">Eliminar</a>
      </p>
    </div>
    <div v-else class="input-group">
      <input v-model="inputCoupon" type="text" class="form-control" placeholder="Ingresa el código aquí" />
      <div class="input-group-append">
        <button class="btn btn-outline-secondary" type="submit">Validar</button>
      </div>
    </div>
    <div v-if="error" class="text-danger small mb-3">
      {{ error }}
    </div>
  </form>
</template>
<script>
import api from '../../api';

export default {
  props: ['item'],
  data() {
    return {
      statusCoupon: false,
      inputCoupon: '',
      error: '',
      typeCuopon: '',
      availablesCuopons: [],
      totalCuopons: ''
    };
  },
  watch: {
    availablesCuopons(value) {
      const { activityId, adhId } = this.tickets
      const ticket = { activityId, adhId };
      if (value.length > 0) {
        this.$emit('availablesCuopons', this.availablesCuopons, ticket);
      } else {
        this.$emit('availablesCuopons', [], ticket);
      }
    },
    tickets(value) {
      if (value) {
        this.availablesCuopons = [];
        this.verifyCoupon();
      }
    }
  },
  computed: {
    tickets() {
      return this.item;
    }
  },
  methods: {
    async verifyCoupon() {
      this.error = '';
      if (!this.inputCoupon) return;
      const payload = {
        dateHourId: this.tickets.adhId,
        text: this.inputCoupon
      };
      this.totalCuopons = await api.verifyCouponByEvent(this.tickets.activityId, payload);
      if (!this.totalCuopons.status) {
        this.setMessageError(this.totalCuopons.message);
      } else {
        this.checkedCoupon();
      }
    },
    removeCoupon() {
      this.inputCoupon = '';
      this.statusCoupon = false;
      this.availablesCuopons = [];
    },
    checkedCoupon() {
      this.tickets.types.forEach((item) => {
        this.totalCuopons.data.filter((elem) => {
          if (elem.ticketTypeId === item.ticketTypeId) {
            this.availablesCuopons.push(elem);
          }
        });
      });

      if (this.availablesCuopons.length > 0) {
        this.statusCoupon = true;
        const ticketsName = this.availablesCuopons.map((el) => el.ticketTypeName);
        this.typeCuopon = ticketsName.toString();
      } else {
        this.setMessageError('Cupon usado/expirado/inválido');
      }
    },
    setMessageError(value) {
      this.error = value;
      this.inputCoupon = '';
      this.statusCoupon = false;
      setTimeout(() => {
        this.error = '';
      }, 7000);
    }
  }
};
</script>
